// extracted by mini-css-extract-plugin
export default {"container":"OrganisationTable_container__2OAWz","headerGroup":"OrganisationTable_headerGroup__1E0R+","searchInput":"OrganisationTable_searchInput__dWWqv"};